import React, { useMemo } from 'react';
import './styles.css'; 
import { useSelector } from 'react-redux';
import { OrderType } from 'common/features/restaurant/restaurantModels';
import { RootState } from 'common/rootReducer';
import usePreventAndroidBackButton from 'helper/usePreventAndroidBackButton';
import { useHistory } from 'react-router-dom';


interface HighlightLinkProps {
  text: string;
  link: string;
  color: string;
}


interface InfoPopupprops{
  isOpen:any, 
  onClose:any,
  isreservation?:boolean

}

const HighlightLink = ({ text, link, color }:HighlightLinkProps) => {
  const history = useHistory();

  // Function to handle the click event
  const handleLinkClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.open(link, '_blank');
  };

  // Split the text to find the #keyword and replace it with a link
  const parts = text.split(/(#\w+)/); // Regular expression to split at #keywords

  return (
    <div style={{color:color}}  className='preorderlinks-style'>
      {parts.map((part, index) => 
        part.startsWith('#') ? (
          <a key={index} href={link} onClick={handleLinkClick} style={{ color: 'blue', cursor: 'pointer',textDecoration: 'underline'  }}>
            {part?.slice(1)} 
          </a>
        ) : (
          part // Render the plain text
        )
      )}
    </div>
  );
};

const CustomerInfoPopup:React.FC<InfoPopupprops> = ({ isOpen, onClose ,isreservation}) => {    

    const restaurantDetails = useSelector(
    (state: any) => state.restaurant.currentRestaurantDetail
    );
// console.log({restaurantDetails});

  
  if (!isOpen) return null;

  return (
    <div className="popup-overlayZa">
      <div className="popup-contentZa" style={{maxWidth:isreservation?"67%":"80%",borderRadius:isreservation?"15px":"2px"}}>
        {isreservation?<h2 style={{margin:"0",padding:"0"}} className='Notice-heading'>Notice</h2>:<h2>Please note :</h2>}
        
        {
          isreservation ?<ul> 
             {restaurantDetails && restaurantDetails.reservationPolicy && (
                < >
                    {restaurantDetails.reservationPolicy.map((item:any, index:number) => (
                    <li  className={`${isreservation?"reservation":"otherOrderTypes"}`}>{item}</li>
                    ))}
                </>
            )}
</ul>:
          <ul style={{marginBottom:isreservation?"0px":"20px"}}>
          {restaurantDetails && restaurantDetails?.preOrderLinks && (
              < >
                  {restaurantDetails?.preOrderLinks?.map((item:any, index:number) => (
                      <li><HighlightLink text={item.text} link={item.link} color={item.colour}/></li>
                  ))}
              </>
            )}
            {restaurantDetails && restaurantDetails.pref && (
                < >
                    {restaurantDetails.pref.map((item:any, index:number) => (
                    <li  className={`${isreservation?"reservation":"otherOrderTypes"}`}>{item}</li>
                    ))}
                </>
            )}
        </ul>
        }
       
        {
          isreservation ?<button className="proceed-btnZa" onClick={onClose}>Proceed</button>
:        <button className="close-btnZa" onClick={onClose}>Close</button>

        }
      </div>
    </div>
  );
};

export default CustomerInfoPopup;
